import React, { useState } from "react";
import SideBar from "./SideBar";
import TopBar from "./TopBar";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import "./aces/DateField";
import { appLocale, fmtDay } from "./aces/Shared";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface Props {
  mainLoading: boolean;
  subList: any[];
  role: string;
  amountInputs: string[];
  isLoading: boolean;
  platformFeeInputs: string[];
  setAmountInputs: React.Dispatch<React.SetStateAction<string[]>>;
  setPlatformFeeInputs: React.Dispatch<React.SetStateAction<string[]>>;
  UpdateUserSubscription: (
    userId: number,
    amount: number,
    platform: number
  ) => Promise<void>;
}

const PaymentInquiry = (props: Props) => {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [emailFilter, setEmailFilter] = useState<string>("");
  const [statusFilter, setStatusFilter] = useState<string>("");
  const { t } = useTranslation();

  const formatDate = (dateStr: string) => fmtDay(dateStr);

  const filteredData = props.subList?.filter((item) => {
    const { user, current } = item;

    // Email filter
    const emailMatch = user.email
      .toLowerCase()
      .includes(emailFilter.toLowerCase());

    // Status filter
    let statusMatch = true;
    if (statusFilter === "Trial") statusMatch = current === null;
    if (statusFilter === "Active") statusMatch = current !== null;

    // Start date filter: only apply if current exists
    let dateMatch = true;
    if (startDate && current) {
      const currentDate = new Date(current.createdAt);
      dateMatch = currentDate >= startDate;
    }

    return emailMatch && statusMatch && dateMatch;
  });

  return (
    <>
      <div className="__dashboard">
        <div className="__dashboard__wrapper">
          <SideBar />
          <div className="__dashboardRightSide">
            <TopBar />
            <div className="__dashboardContent">
              <div className="__pageHeading">{t("payment.heading")}</div>
              <div className="__myTraining">
                <div className="billingTop">
                  <div className="statusSelec"></div>
                </div>

                {/* Filters */}
                <div className="form__paremt">
                  <div className="formFields">
                    {props.role === "SUPER_ADMIN" && (
                      <div className="__input__group">
                        <label>{t("payment.email")}</label>
                        <input
                          type="email"
                          placeholder={t("payment.emailPlaceholder")}
                          value={emailFilter}
                          onChange={(e) => setEmailFilter(e.target.value)}
                        />
                      </div>
                    )}
                    <div className="__input__group">
                      <label>{t("payment.status")}</label>
                      <select
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                      >
                        <option value="">{t("payment.all")}</option>
                        <option value="Trial">{t("payment.trial")}</option>
                        <option value="Active">{t("payment.active")}</option>
                      </select>
                    </div>
                    <div className="__input__group">
                      <label>{t("payment.startDate")}</label>
                      <div className="date-range-container">
                        <DatePicker
                          selected={startDate}
                          onChange={(date: Date | null) => setStartDate(date)}
                          placeholderText={t("payment.startDate")}
                          locale={appLocale()}
                          dateFormat="dd/MM/yyyy"
                          className="date-input"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Table */}
                <div className="row">
                  <div className="col-lg-12 col-12">
                    <div className="__defaultTable">
                      <table>
                        <thead>
                          <tr>
                            <th>{t("payment.userName")}</th>
                            <th>{t("payment.email")}</th>
                            <th>{t("payment.role")}</th>
                            <th>{t("payment.trialDate")}</th>
                            <th>{t("payment.packageAmount")}</th>
                            <th>{t("payment.status")}</th>
                            <th>{t("payment.futurePackage")}</th>
                            {props.role === "SUPER_ADMIN" && (
                              <th>{t("common.edit_package_fee")}</th>
                            )}
                          </tr>
                        </thead>

                        <tbody>
                          {props.mainLoading ? (
                            <tr>
                              <td colSpan={8} style={{ textAlign: "center" }}>
                                <i
                                  className="ri-loader-4-line ri-spin"
                                  style={{ fontSize: "20px" }}
                                ></i>{" "}
                                Loading Payment Inquiries...
                              </td>
                            </tr>
                          ) : (
                            <>
                              {filteredData.map((item, index) => {
                                const { user, current, future } = item;
                                return (
                                  <tr key={index}>
                                    <td>
                                      <div className="flex-gap">
                                        <div className="usernameIcon">
                                          {user?.name?.charAt(0) || "U"}
                                        </div>
                                        <div>
                                          <div>{user?.name || "-"}</div>
                                        </div>
                                      </div>
                                    </td>
                                    <td className="email_cell">
                                      {user?.email || "-"}
                                    </td>
                                    <td>{user?.role || "-"}</td>
                                    <td>
                                      {current
                                        ? formatDate(current.createdAt)
                                        : "Free Trial (7 days)"}
                                    </td>
                                    <td>
                                       {current ? (
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "2px",
                                          }}
                                        >
                                          <div>
                                            <strong>
                                              {t("common.amount")} (Per Checklist):
                                            </strong>
                                           {" "} €{current.amount}
                                          </div>
                                          <div>
                                            <strong>
                                              {t("common.platform_fee")} (Monthly):
                                            </strong>
                                            {" "} €{current.platformFee}
                                          </div>
                                        
                                        </div>
                                      ) : (
                                        "-"
                                      )}
                                    </td>
                                    <td>
                                      {current ? (
                                        <button className="paid_btn">
                                          {t("payment.active")}
                                        </button>
                                      ) : (
                                        <button className="unpaid_btn">
                                          {t("payment.trial")}
                                        </button>
                                      )}
                                    </td>
                                    <td>
                                      {future ? (
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "2px",
                                          }}
                                        >
                                          <div>
                                            <strong>
                                              {t("common.amount")}:
                                            </strong>
                                            €{future.amount}
                                          </div>
                                          <div>
                                            <strong>
                                              {t("common.platform_fee")}:
                                            </strong>
                                            €{future.platformFee}
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              color: "#555",
                                            }}
                                          >
                                            {formatDate(future.effectiveFrom)}
                                          </div>
                                        </div>
                                      ) : (
                                        "-"
                                      )}
                                    </td>

                                    {props.role === "SUPER_ADMIN" && (
                                      <td>
                                        {props.isLoading ? (
                                          <Spinner
                                            animation="border"
                                            role="status"
                                            size="sm"
                                            style={{ marginLeft: "60px" }}
                                          >
                                            <span className="visually-hidden">
                                              {t("payment.loading")}
                                            </span>
                                          </Spinner>
                                        ) : (
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "4px",
                                              alignItems: "center",
                                            }}
                                          >
                                            <input
                                              type="number"
                                              placeholder={t("aces.payment.amount")}
                                              value={
                                                props.amountInputs[index] || ""
                                              }
                                              onChange={(e) => {
                                                const updated = [
                                                  ...props.amountInputs,
                                                ];
                                                updated[index] = e.target.value;
                                                props.setAmountInputs(updated);
                                              }}
                                              style={{
                                                width: "60px",
                                                padding: "2px",
                                              }}
                                            />
                                            <input
                                              type="number"
                                              placeholder={t("aces.payment.fee")}
                                              value={
                                                props.platformFeeInputs[
                                                  index
                                                ] || ""
                                              }
                                              onChange={(e) => {
                                                const updated = [
                                                  ...props.platformFeeInputs,
                                                ];
                                                updated[index] = e.target.value;
                                                props.setPlatformFeeInputs(
                                                  updated
                                                );
                                              }}
                                              style={{
                                                width: "60px",
                                                padding: "2px",
                                              }}
                                            />
                                            <button
                                              onClick={() => {
                                                const amount =
                                                  props.amountInputs[index];
                                                const platform =
                                                  props.platformFeeInputs[
                                                    index
                                                  ];
                                                if (
                                                  amount &&
                                                  !isNaN(Number(amount)) &&
                                                  !isNaN(Number(platform))
                                                ) {
                                                  props.UpdateUserSubscription(
                                                    user.id,
                                                    parseInt(amount),
                                                    parseInt(platform)
                                                  );
                                                } else {
                                                  alert(
                                                    "Invalid or empty amount or fee."
                                                  );
                                                }
                                              }}
                                              className="save-btn"
                                              style={{
                                                backgroundColor: "#28a745",
                                                color: "#fff",
                                                border: "none",
                                                padding: "4px 8px",
                                                borderRadius: "4px",
                                                cursor: "pointer",
                                              }}
                                            >
                                              Save
                                            </button>
                                          </div>
                                        )}
                                      </td>
                                    )}
                                  </tr>
                                );
                              })}
                              {filteredData.length === 0 && (
                                <tr>
                                  <td colSpan={8} className="nofound">
                                    {t("payment.noRecords")}
                                  </td>
                                </tr>
                              )}
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentInquiry;
